import { Grid } from '@material-ui/core'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { FormattedMessage } from 'react-intl'
import { fontFamilyMonserrat } from '../../../../../theme'
import SvgCross from '../../../../../icons/SvgCross'
import Button from '../../../../../components/button/Button'
import { getInfoForDemandeTechnique } from '../../../../../enums/demandesTechniqueEnum'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

const useStyle = makeStyles<Theme, { isBailleur: boolean }>(
	(theme) => (
		{
			...styles(theme),
			infoPin: {
				height: '100%'
			},
			titreStyle: {
				color: props => props.isBailleur ? theme.gecina.green : theme.gecina.blue,
				fontFamily: fontFamilyMonserrat,
				fontSize: '1.4em',
				fontWeight: 'bold',
				textTransform: 'uppercase'
			},
			descriptionStyle: {
				fontFamily: fontFamilyMonserrat,
				fontSize: '1.2em',
				fontWeight: 500,
				height:'fit-content',
				padding: '0 10px',
			},
			boutonBlocStyle: {
				justifyItems: 'flex-end',
				alignSelf: 'self-end'
			},
			pinHeader: {
				height: 'fit-content'
			},
			crossStyle: {
				justifyContent: 'end',
				cursor: 'pointer'
			}
		}
	)
)

interface AcceptingProps {
	selectedDemandeTechnique: string
	priseEnChargeBailleur: boolean
	setSelected: () => void
}

type PopinDemandeTechniqueProps = AcceptingProps

const PopinDemandeTechnique: React.FC<PopinDemandeTechniqueProps> = (
	{
		selectedDemandeTechnique,
		priseEnChargeBailleur,
		setSelected
	}
) => {
	const isBailleur = priseEnChargeBailleur || getInfoForDemandeTechnique(selectedDemandeTechnique).parentKey === "bailleur"
	const classes = useStyle({isBailleur})
	const typeDemande = priseEnChargeBailleur ? "bailleur" : getInfoForDemandeTechnique(selectedDemandeTechnique).parentKey

	const renderBouton = () => {
		return <Button
			background={isBailleur ? 'backgroundGreen' : 'backgroundBlue'}
			color="colorWhite"
			textStyle="text8"
			onClick={setSelected}
			border="borderWhite"
		>
			<FormattedMessage
				id={`requests.makeRequest.step3.private.boutons.${typeDemande}`}
				defaultMessage="Demande d'information"
				description="Demande d'information btn"
			/>
		</Button>
	}

	return (
		<Grid container className={classes.infoPin}>
			<Grid container item className={classes.pinHeader}>
				<Grid container item className={classes.titreStyle} xs={11}>
					<FormattedMessage id={`requests.makeRequest.step3.${selectedDemandeTechnique}`} />
				</Grid>
				<Grid container item xs={1} className={classes.crossStyle}>
					<SvgCross width={20} height={20} />
				</Grid>
			</Grid>
			<Grid container item className={classes.descriptionStyle}>
				<FormattedMessage id={`requests.makeRequest.step3.private.description.${selectedDemandeTechnique}`} />
			</Grid>
			<Grid xs={12} className={classes.boutonBlocStyle}>
				<Grid container item xs={12} md={8}>
					{renderBouton()}
				</Grid>
			</Grid>
		</Grid>
	)
}

export default PopinDemandeTechnique